import * as d3Scale from "d3-scale";

// D3 polylinear scale was proving problematic, so we wrap up some of the logic here instead.
export default (video, duration) => {
    return position => {
        const { sectionDefinitions } = video.sections;

        if (!sectionDefinitions.length || sectionDefinitions[0].videoTimeExtents[0] < 0) {
            const timeScale = d3Scale.scaleTime()
                .domain([0, duration])
                .range(video.processed.extents.time);
            return new Date(timeScale(position));
        }

        const thisSection = sectionDefinitions.find(
            def =>
                position >= def.videoTimeExtents[0] &&
                position < def.videoTimeExtents[1]
        );
        if (!thisSection) {
            throw new Error("time out of bounds");
        }
        const interp = d3Scale.scaleLinear()
            .range([0, thisSection.clockTimeExtents[1] - thisSection.clockTimeExtents[0]])
            .domain(thisSection.videoTimeExtents);

        const amt = interp(position);
        return new Date(thisSection.clockTimeExtents[0].getTime() + amt);
    };
};



// WEBPACK FOOTER //
// ./src/modules/section-time-scale.js